<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter
                    :orderbutton="true"
                    :showCompleted="true"
                    :listStatus="listStatus"
                    :orderSummary="summary"
                    :headers="headers"
                    :viewName="viewName"
                    v-on:applyFilter="applyFilter"
                    v-on:quickFilter="quickFilter"
                ></hpo-filter>

                <div v-if="selectedRows.length" class="px-5 pb-4">
                    <v-sheet outlined rounded class="pa-3">
                        <v-row dense align="center">
                            <v-col cols="12" sm="6" md="2">
                                <strong>Đã chọn: {{ selectedRows.length }} đơn</strong>
                            </v-col>
                            <v-col cols="6" sm="3" md="2">
                                Tiền hàng:
                                <strong>{{ selectedSummary.ProductAmount | currency('', 2) }}</strong>
                            </v-col>
                            <v-col cols="6" sm="3" md="2">
                                Tiền ship:
                                <strong>{{ selectedSummary.FeeShip | currency('', 2) }}</strong>
                            </v-col>
                            <v-col cols="6" sm="3" md="2">
                                Tiền mua thật:
                                <strong>{{ selectedSummary.TotalRealAmountCNY | currency('', 2) }}</strong>
                            </v-col>
                            <v-col cols="6" sm="3" md="2">
                                Đàm phán:
                                <strong
                                    :class="{ 'error--text': selectedSummary.NegotiationDiff < 0 }"
                                >
                                    {{ selectedSummary.NegotiationDiff | currency('', 2) }}
                                </strong>
                            </v-col>
                            <v-col v-if="canMarkBought" cols="12" md="2" class="text-md-right">
                                <v-btn
                                    small
                                    color="success"
                                    outlined
                                    rounded
                                    :disabled="!selectedBuyingRows.length"
                                    @click="confirmDialog = true"
                                >
                                    <v-icon left>fa-check</v-icon>
                                    Đã mua ({{ selectedBuyingRows.length }})
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </div>

                <v-data-table
                    v-model="selectedRows"
                    fixed-header
                    height="600px"
                    show-select
                    item-key="OrderID"
                    :headers="headers"
                    :items="items"
                    :options.sync="pagination"
                    :server-items-length="total_rows"
                    :footer-props="items_per_page"
                    :must-sort="true"
                    :loading="loading"
                    :mobile-breakpoint="100"
                >
                    <template v-slot:item="{ item, isSelected, select }">
                        <tr :id="'r-' + item.OrderID">
                            <td class="cell-check" @click="select(!isSelected)">
                                <v-checkbox
                                    :input-value="isSelected"
                                    hide-details
                                    class="ma-0 pa-0"
                                ></v-checkbox>
                            </td>
                            <td>
                                <a target="_blank" :href="'/don-hang/' + item.OrderID">
                                    MD{{ item.OrderID }}
                                </a>
                            </td>
                            <td>{{ item.OrderCode }}</td>
                            <td>{{ item.CustomerName }}</td>
                            <td>{{ item.PurchaseName }}</td>
                            <td>{{ item.CSName }}</td>
                            <td class="text-end">{{ item.ProductAmount | currency('', 2) }}</td>
                            <td class="text-end">{{ item.FeeShip | currency('', 2) }}</td>
                            <td class="text-end">{{ item.TotalAmount | currency('', 2) }}</td>
                            <td class="text-end real-amount">{{ item.TotalRealAmountCNY | currency('', 2) }}</td>
                            <td
                                class="text-end"
                                :class="{ 'error--text': item.NegotiationDiff < 0 }"
                            >
                                {{ item.NegotiationDiff | currency('', 2) }}
                            </td>
                            <td :style="{ color: get_status_color(item.Status, order_status) }">
                                {{ item.Status | display_value(order_status) }}
                            </td>
                            <td>{{ item.WaitBoughtDate | display_date('DD-MM-YYYY HH:mm:ss') }}</td>
                            <td>{{ item.BoughtDate | display_date('DD-MM-YYYY HH:mm:ss') }}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr class="total-summary-td">
                            <td></td>
                            <td colspan="5" class="text-center font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{ summary.ProductAmount | currency('', 2) }}</td>
                            <td class="text-end font-weight-bold">{{ summary.FeeShip | currency('', 2) }}</td>
                            <td class="text-end font-weight-bold">{{ summary.TotalAmount | currency('', 2) }}</td>
                            <td class="text-end font-weight-bold real-amount">{{ summary.TotalRealAmountCNY | currency('', 2) }}</td>
                            <td
                                class="text-end font-weight-bold"
                                :class="{ 'error--text': summary.NegotiationDiff < 0 }"
                            >
                                {{ summary.NegotiationDiff | currency('', 2) }}
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>

    <v-dialog v-model="confirmDialog" max-width="520" persistent>
        <v-card>
            <v-card-title class="headline">Xác nhận đã mua hàng</v-card-title>
            <v-card-text>
                Chuyển {{ selectedBuyingRows.length }} đơn đang mua hàng sang trạng thái “Chờ phát hàng”?
                Các đơn ở trạng thái khác sẽ không bị thay đổi.
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="updatingStatus" @click="confirmDialog = false">Hủy</v-btn>
                <v-btn color="success" :loading="updatingStatus" @click="markBought">Xác nhận</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import { mapState } from 'vuex';
import configs from '@/configs';
import Filtering from '@/components/Filtering';
import _ from 'lodash';

export default {
    components: {
        'hpo-filter': Filtering
    },
    data() {
        return {
            order_status: configs.ORDER_STATUS,
            pagination: { ...configs.PAGINATION, sortBy: ['OrderID'] },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: 'accountantorder_list',
            filterConditions: [],
            quickFilterConditions: [],
            selectedRows: [],
            confirmDialog: false,
            updatingStatus: false
        };
    },
    watch: {
        pagination: {
            handler() {
                const filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : [];
                this.filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.accountant_order.all.data,
            total_rows: state => state.accountant_order.all.total,
            summary: state => state.accountant_order.all.summary || {},
            loading: state => state.accountant_order.loading
        }),
        tableConfig() {
            return {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) === configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) === configs.ROLE_TYPE.Payment;
        },
        canMarkBought() {
            return this.adminRole || this.paymentRole;
        },
        selectedBuyingRows() {
            return _.filter(
                this.selectedRows,
                item => Number(item.Status) === configs.ORDER_STATUS_ENUM.cho_mua_hang
            );
        },
        selectedSummary() {
            return _.reduce(this.selectedRows, (summary, item) => {
                summary.ProductAmount += Number(item.ProductAmount) || 0;
                summary.FeeShip += Number(item.FeeShip) || 0;
                summary.TotalRealAmountCNY += Number(item.TotalRealAmountCNY) || 0;
                summary.NegotiationDiff += Number(item.NegotiationDiff) || 0;
                return summary;
            }, {
                ProductAmount: 0,
                FeeShip: 0,
                TotalRealAmountCNY: 0,
                NegotiationDiff: 0
            });
        },
        listStatus() {
            return _.filter(configs.ORDER_STATUS, status => ![0, 1, 3].includes(status.value));
        },
        headers() {
            const headers = [
                {
                    text: 'Mã đơn hàng',
                    value: 'OrderID',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.Number
                },
                {
                    text: 'Mã đơn TQ',
                    value: 'OrderCode',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String
                },
                {
                    text: 'Khách hàng',
                    value: 'CustomerName',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String
                },
                {
                    text: 'Mua hàng',
                    value: 'PurchaseName',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String
                },
                {
                    text: 'Nhân viên CSKH',
                    value: 'CSName',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String
                },
                {
                    text: 'Tiền hàng (¥)',
                    value: 'ProductAmount',
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE.Number
                },
                {
                    text: 'Phí ship (¥)',
                    value: 'FeeShip',
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE.Number
                }
            ];

            headers.push(
                {
                    text: 'Tổng phí (¥)',
                    value: 'TotalAmount',
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE.Number
                },
                {
                    text: 'Tiền mua thật (¥)',
                    value: 'TotalRealAmountCNY',
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE.Number
                },
                {
                    text: 'Chênh lệch đàm phán (¥)',
                    value: 'NegotiationDiff',
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE.Number
                },
                {
                    text: 'Trạng thái',
                    value: 'Status',
                    filterable: true,
                    values: this.listStatus,
                    dataType: configs.DATA_TYPE.Enum
                },
                {
                    text: 'Chờ mua hàng',
                    value: 'WaitBoughtDate',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.Date
                },
                {
                    text: 'Ngày hoàn thành',
                    value: 'BoughtDate',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.Date
                },
            );
            return headers;
        }
    },
    methods: {
        createData() {
            this.$store.dispatch('accountant_order/export', this.tableConfig);
        },
        filter_data() {
            this.selectedRows = [];
            this.$store.dispatch('accountant_order/getList', this.tableConfig);
        },
        applyFilter(filterConditions) {
            const sortBy = this.pagination.sortBy;
            const sortDesc = this.pagination.sortDesc;
            this.pagination = { ...configs.PAGINATION, sortBy, sortDesc };
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        async markBought() {
            this.updatingStatus = true;
            try {
                await this.$store.dispatch('accountant_order/markBought', {
                    orderIds: _.map(this.selectedBuyingRows, 'OrderID'),
                    param: this.tableConfig
                });
                this.confirmDialog = false;
                this.selectedRows = [];
            }
            finally {
                this.updatingStatus = false;
            }
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on('REQUEST_CREATE_DATA', this.createData);
        this.$root.$on('REQUEST_REFRESH_DATA', this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off('REQUEST_CREATE_DATA', this.createData);
        this.$root.$off('REQUEST_REFRESH_DATA', this.filter_data);
    }
};
</script>

<style scoped>
.real-amount {
    background-color: #f7ffd5;
}
</style>
